import watermarkImg from '../assets/pictures/spine_splash_page.svg'

export default function Watermark() {
  return <img className="watermark" src={watermarkImg} alt="" aria-hidden="true" />
}
